import React from "react";
import { Card, Tag } from "@chakra-ui/react";
import "../../Animations.css";
import { CourseLevel } from "@shared_types";
import { getLevelColor } from "../../styles/courseStyles";
import {
  getCardBaseStyles,
  getCardLayoutStyles,
  getCardContentStyles,
  getTagStyles,
} from "../../styles/cardStyles";
import { useCardPressAnimationAndHaptic } from "../../hooks/useCardPressAnimation";

interface SquareCardProps {
  emoji: string | React.ReactNode;
  title: string;
  selected?: boolean;
  subtitle?: string;
  onClick?: () => void;
  completion?: number;
  level: CourseLevel;
  progress: number;
}

const CoursesCardRectangle: React.FC<SquareCardProps> = ({
  emoji,
  title,
  subtitle,
  selected = false,
  onClick,
  completion,
  level,
  progress,
}) => {
  const { isPressed, handleCardClick } =
    useCardPressAnimationAndHaptic(onClick);
  const levelColor = getLevelColor(level);
  const baseStyles = getCardBaseStyles(selected, isPressed);
  const layoutStyles = getCardLayoutStyles("rectangle");
  const contentStyles = getCardContentStyles(
    completion ? "default" : "centered"
  );

  return (
    <Card
      direction={"column"}
      justifyContent={completion ? "start" : "center"}
      {...layoutStyles}
      {...baseStyles}
      className={`${baseStyles.className} ${contentStyles.className}`}
      onClick={handleCardClick}
      style={{ flex: 1 }}
    >
      <div className="flex flex-row w-full h-full items-center justify-start text-center align-middle">
        <div className="text-3xl mr-3">{emoji}</div>
        <div className="flex flex-col w-full items-start justify-start">
          <div className="font-semibold text-xl line-clamp-1">{title}</div>
          <div className="text-sm text-wrap text-start line-clamp-1 text-[var(--color-grey)]">
            {subtitle ? subtitle : ""}
          </div>
        </div>
      </div>
      <div className="flex absolute top-[10px] right-[12px] items-end">
        {progress > 0 && progress < 100 ? (
          <Tag {...getTagStyles("progress")}>{`${progress}%`}</Tag>
        ) : (
          <Tag {...getTagStyles("level")} color={levelColor}>
            {level?.name?.toUpperCase()}
          </Tag>
        )}
      </div>
    </Card>
  );
};

export default CoursesCardRectangle;
